import React, { useContext, useState, useEffect } from 'react'
import { HrmStore } from '../../Context/HrmContext'
import { useNavigate } from 'react-router-dom'
import LoadingData from '../MiniComponent/LoadingData'

const PAGE_SIZE = 5

const ClientRequirmentTable = ({ data, loading }) => {
    let { changeDateYear, convertToReadableDateTime } = useContext(HrmStore)
    let navigate = useNavigate()

    const [search, setSearch] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const [pageInput, setPageInput] = useState(1)

    // Filter by search
    const filtered = (data || []).filter(obj => {
        const q = search.toLowerCase()
        return (
            (obj.job_title || '').toLowerCase().includes(q) ||
            (obj.client_details?.company_name || '').toLowerCase().includes(q) ||
            (obj.job_location || '').toLowerCase().includes(q) ||
            (obj.required_skills || '').toLowerCase().includes(q) ||
            (obj.added_by || '').toLowerCase().includes(q)
        )
    })

    const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE))

    // Reset to page 1 on search
    useEffect(() => {
        setCurrentPage(1)
        setPageInput(1)
    }, [search])

    useEffect(() => {
        setPageInput(currentPage)
    }, [currentPage])

    const paginated = filtered.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE)

    const goToPage = (page) => {
        const p = Math.max(1, Math.min(page, totalPages))
        setCurrentPage(p)
        setPageInput(p)
    }

    return (
        <div className='flex flex-col gap-2'>
            <div className='flex justify-between items-center gap-2 flex-wrap'>
                <h3>All Requirements</h3>
                {/* Search bar */}
                <div className="flex justify-between items-center gap-2 flex-wrap">
                    {/* <p className="text-sm text-gray-500 m-0">
                    Showing <strong>{filtered.length}</strong> requirement{filtered.length !== 1 ? 's' : ''}
                </p> */}
                    <input
                        type="text"
                        placeholder="Search by job title, client, location, skills..."
                        className="border border-gray-300 rounded px-3 py-1.5 text-sm outline-none w-72 focus:ring-2 focus:ring-blue-400"
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                </div>
            </div>

            {/* Table */}
            <main className='tablebg my-2 rounded table-responsive h-[70vh] overflow-y-scroll'>
                <table className='w-full'>
                    <thead>
                        <tr className='sticky top-0'>
                            <th>SI No</th>
                            <th>Client Organization</th>
                            <th>Added By</th>
                            <th>Job Name</th>
                            <th>Openings</th>
                            <th>Job Location</th>
                            <th>Package</th>
                            <th>Experience</th>
                            <th>Qualification</th>
                            <th>Skills</th>
                            <th>Interview Dates</th>
                            <th>Application Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="12">
                                    <LoadingData css="h-[20vh]" />
                                </td>
                            </tr>
                        ) : paginated.length > 0 ? (
                            paginated.map((obj, index) => (
                                <tr
                                    key={obj.id}
                                    className="hover:bg-slate-50 cursor-pointer"
                                    onClick={() => navigate(`/client/recuirment/${obj.id}`)}
                                >
                                    <td>{(currentPage - 1) * PAGE_SIZE + index + 1}</td>
                                    <td>{obj.client_details?.company_name || '—'}</td>
                                    <td>{obj.added_by || '—'}</td>
                                    <td>{obj.job_title || '—'}</td>
                                    <td>{obj.open_positions ?? '—'}</td>
                                    <td>{obj.job_location || '—'}</td>
                                    <td>
                                        {obj.package_min ? Math.round(obj.package_min) : ''}
                                        {obj.package_max && obj.package_min ? ' - ' : ''}
                                        {obj.package_max ? Math.round(obj.package_max) : ''}
                                        {!obj.package_min && !obj.package_max ? '—' : ''}
                                    </td>
                                    <td>
                                        {obj.experience_min ? Math.round(obj.experience_min) : ''}
                                        {obj.experience_max && obj.experience_min ? ' - ' : ''}
                                        {obj.experience_max ? Math.round(obj.experience_max) : ''}
                                        {!obj.experience_min && !obj.experience_max ? '—' : ''}
                                    </td>
                                    <td>{obj.qualification || '—'}</td>
                                    <td className="max-w-[120px] truncate" title={obj.required_skills}>
                                        {obj.required_skills || '—'}
                                    </td>
                                    <td>
                                        {obj.hiring_start_date && changeDateYear(obj.hiring_start_date)}
                                        {obj.hiring_end_date && obj.hiring_start_date ? ' - ' : ''}
                                        {obj.hiring_end_date && changeDateYear(obj.hiring_end_date)}
                                        {!obj.hiring_start_date && !obj.hiring_end_date ? '—' : ''}
                                    </td>
                                    <td>{obj.added_on ? convertToReadableDateTime(obj.added_on) : '—'}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="12" className="text-center py-8 italic text-gray-400">
                                    {search ? `No requirements found for "${search}"` : 'No requirements found.'}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </main>

            {/* Pagination — only show if there's data */}
            {filtered.length > PAGE_SIZE && (
                <div className="d-flex justify-content-between align-items-center mt-1 bg-white p-2 rounded shadow-sm">
                    <div className="text-sm">
                        Total: <strong>{filtered.length}</strong> | Page: <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                        <button
                            className="btn btn-primary btn-sm rounded px-2"
                            disabled={currentPage === 1}
                            onClick={() => goToPage(currentPage - 1)}
                        >
                            Previous
                        </button>

                        <div className="small px-3 bg-primary text-white rounded py-1">
                            {currentPage} of {totalPages}
                        </div>

                        <button
                            className="btn btn-primary btn-sm"
                            disabled={currentPage === totalPages}
                            onClick={() => goToPage(currentPage + 1)}
                        >
                            Next
                        </button>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                        <span className="text-sm">Page</span>
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            style={{ width: '55px' }}
                            min={1}
                            max={totalPages}
                            value={pageInput}
                            onChange={e => setPageInput(e.target.value)}
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    goToPage(Number(pageInput))
                                }
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default ClientRequirmentTable